import { EgretLoadable } from 'egret'
import { authRoles } from '../../auth/authRoles'
import { Trans } from '@lingui/macro'

export const SAT_PATHS = {
  MY_ASSESSMENTS: '/sat/my-assessments',
  SAT_LANDING: '/sat/organizational-compass'
}

const SATLanding = EgretLoadable({
  loader: () => import('./CompassLanding')
})

const MyAssessments = EgretLoadable({
  loader: () => import('./CompassAssessments')
})

const satRoutes = [
  {
    path: '/sat/organizational-compass',
    component: SATLanding,
    isTranslatable: true,
    auth: authRoles.grantee,
    label: <Trans>NAVIGATIONS_ORGANIZATIONAL_COMPASS</Trans>
  },
  {
    path: '/sat/my-assessments',
    component: MyAssessments,
    isTranslatable: true,
    auth: authRoles.grantee,
    label: <Trans>NAVIGATIONS_ASSESSMENTS</Trans>,
    showCollapseBtn: true
  }
]

export default satRoutes
